import React, { Component } from 'react'

class Headline extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      alt: props.alt,
      generated: props.generated,
      src: 'images/graphic-text/' + props.src + '.svg',
    };
  }

  setText(newText) {
    this.setState({
      text: newText
    });
  }

  render() {
    var className = 'headline ' + (this.state.generated ? 'headline--delayed' : '');

    return (
      <img src={this.state.src} alt={this.state.alt} className={className} />
    );
  }
}

export default Headline



// WEBPACK FOOTER //
// ./src/scripts/components/Headline.js